import React from "react";

const Item = ({ text }) => {
  return (
    <li className="services__modal-service">
      <i className="uil uil-check-circle services__modal-icon"></i>
      <p className="services__modal-info">{text}</p>
    </li>
  );
};

export default Item;
